import { apiClient } from '@/services/api.service'

const RetailersService = {
  getRetailers: () => apiClient().get('/v1/admin/retailers/')
}

export default RetailersService
